import axios from "axios";

export const api = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/api`, withCredentials: true });
export const errorText = (err, fallback) => err?.response?.data?.detail || fallback;
